import { useEffect, useState } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useNavigate, useParams } from 'react-router-dom';
import { getLoginRequest } from '../auth/msal-config.js';
import { useAccessToken } from '../auth/use-access-token.js';
import { openClinicLink, readClinicLink, useClinicRead } from '../api/clinics.js';
import { ClinicHead } from '../components/clinic-head.js';
import { WaitNote } from '../components/wait-note.js';

/**
 * The direct link (board 3; ruled 30 October). Signed out it shows what the
 * clinic is, never who is in it, and one button: Sign in. Microsoft's page
 * offers an account to anyone without one, and the address comes back here.
 *
 * Signed in, the link authorizes them - forwarded links work - and they land
 * on the clinic in Book. ProfileGate lets a signed-out visitor through to this
 * route alone, and finishes a new parent's profile in place first.
 */
export function ClinicLinkRoute() {
  const { token = '' } = useParams();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const getToken = useAccessToken();
  const signedIn = useIsAuthenticated();
  const { state } = useClinicRead(signedIn ? null : () => readClinicLink(token), token);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    if (!signedIn) return;
    let cancelled = false;
    openClinicLink(getToken, token)
      .then((opened) => {
        if (!cancelled) navigate(`/booking/clinics/${opened.clinic_id}`, { replace: true });
      })
      .catch(() => {
        if (!cancelled) setGone(true);
      });
    return () => {
      cancelled = true;
    };
  }, [signedIn, getToken, token, navigate]);

  if (signedIn ? gone : state.status === 'gone' || state.status === 'failed') {
    return (
      <section className="panel">
        <h2>That clinic has gone</h2>
      </section>
    );
  }
  if (signedIn || state.status !== 'ready') return <WaitNote className="empty">Checking…</WaitNote>;

  return (
    <>
      <ClinicHead clinic={state.clinic} />
      <button type="button" className="primary" onClick={() => void instance.loginRedirect(getLoginRequest())}>
        Sign in
      </button>
    </>
  );
}
